import { VYTA_URL } from "@/data/services";

/**
 * Enlace oficial a VYTA Digital (https://vytadigital.com/).
 * Se usa en todas las secciones donde se menciona la marca.
 */
export function VytaLink({ className = "" }) {
    return (
        <a
            href={VYTA_URL}
            target="_blank"
            rel="noopener noreferrer"
            title="VYTA Digital — Consultoría en Inteligencia Artificial"
            className={`underline underline-offset-4 decoration-brand-line hover:decoration-brand-electric transition-colors ${className}`}
        >
            VYTA Digital
        </a>
    );
}

/**
 * Renderiza un texto convirtiendo cada mención de "VYTA Digital"
 * en un enlace natural a su web oficial.
 */
export function VytaText({ text, className = "" }) {
    const parts = String(text).split("VYTA Digital");
    if (parts.length === 1) return <>{text}</>;
    return (
        <>
            {parts.map((p, i) => (
                <span key={i}>
                    {p}
                    {i < parts.length - 1 && <VytaLink className={className} />}
                </span>
            ))}
        </>
    );
}
